// extracted by mini-css-extract-plugin
export var headerTop = "styles-module--header-top--P7mnh";
export var headerTopBanner = "styles-module--header-top-banner--vUkr3";
export var headerTopText = "styles-module--header-top-text---2P3Z";
export var logoHeader = "styles-module--logo-header--r0Qgm";